import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReadOnlyMode } from '../../hooks/useReadOnlyMode';

const SubscriptionBanner: React.FC = () => {
  const { isReadOnly } = useReadOnlyMode();
  const navigate = useNavigate();
  const location = useLocation();

  if (!isReadOnly) return null;

  return (
    <div className="sticky top-0 z-20 w-full border-b border-amber-300/40 bg-amber-50/95 dark:bg-amber-900/20 backdrop-blur supports-[backdrop-filter]:bg-amber-50/75 dark:supports-[backdrop-filter]:bg-amber-900/15">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 py-2 flex items-center justify-between">
        <div className="flex items-center space-x-2 text-amber-900 dark:text-amber-200">
          <AlertTriangle size={16} className="text-amber-600 dark:text-amber-300" />
          <span className="text-sm">You're in view-only mode. Upgrade to edit, run the agent, and publish.</span>
        </div>
        <button
          onClick={() => navigate('/subscription-required', { state: { from: location } })}
          className="ml-3 shrink-0 text-xs px-3 py-1.5 rounded-lg bg-brand-action text-brand-action-text hover:bg-brand-action-hover transition-colors"
        >
          Upgrade
        </button>
      </div>
    </div>
  );
};

export default SubscriptionBanner;


